import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const pragyaaiRoutes = [
  {
    path: 'manage-bot',
    component: () => import('./views/PragyaAILayout.vue'),
    children: [
      {
        path: '',
        name: 'pragya-ai',
        component: () => import('./views/LandingPageView.vue'),
        meta: {
          requiredRole: ROLES.STUDENT,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForLearner,
        },
      },
      {
        path: 'chat',
        name: 'pragya-ai-chat',
        component: () => import('./views/ChatView.vue'),
        meta: {
          requiredRole: ROLES.SUPER_ADMIN,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForNonLearner,
        },
      },
      {
        path: 'upload',
        name: 'pragya-ai-upload',
        redirect: { name: 'pragya-ai-manage-content', query: { action: 'upload' } },
      },
      {
        path: 'manage-content',
        name: 'pragya-ai-manage-content',
        component: () => import('./views/ManageContentView.vue'),
        meta: {
          requiredRole: ROLES.INSTRUCTOR,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForNonLearner,
        },
      },
      {
        path: 'sync-knowledge-base',
        name: 'manage-bot-sync-knowledge-base',
        component: () => import('@/domains/@platform/admin/views/VectorDbSyncView.vue'),
        meta: {
          requiredRole: ROLES.INSTRUCTOR,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForNonLearner,
        },
      },
      {
        path: 'configure-bot',
        name: 'manage-bot-configure-bot',
        component: () => import('@/domains/@bot/pragyaai/views/ConfigureBotView.vue'),
        meta: {
          requiredRole: ROLES.INSTRUCTOR,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForNonLearner,
        },
      },
      {
        path: 'configure-questions',
        name: 'manage-bot-configure-questions',
        redirect: { name: 'manage-bot-configure-bot', query: { panel: 'questions' } },
      },
      {
        path: 'analytics',
        name: 'manage-bot-analytics',
        component: () => import('./views/AnalyticsView.vue'),
        meta: {
          requiredRole: ROLES.INSTITUTION_ADMIN,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForNonLearner,
        },
      },
      {
        path: 'docs',
        name: 'pragya-ai-docs',
        component: () => import('./views/DocumentationView.vue'),
        meta: {
          requiredRole: ROLES.STUDENT,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForLearner,
        },
      },
      {
        path: 'courses/:pathMatch(.*)*',
        name: 'pragyaai-course-list',
        component: () => import('./views/CourseListView.vue'),
        meta: {
          requiredRole: ROLES.STUDENT,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForLearner,
        },
      },
      {
        path: 'widget-courses',
        name: 'pragya-ai-widget-courses',
        component: () => import('./views/WidgetCoursesView.vue'),
        meta: {
          requiredRole: ROLES.SUPER_ADMIN,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.AI_ASSISTANT_BOT,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.enableForNonLearner,
        },
      },
    ],
  },
  {
    path: 'ai/:pathMatch(.*)*',
    redirect: to => `/manage-bot/${to.params.pathMatch || ''}`,
  },
];

export const pragyaaiPublicRoutes = [
  {
    path: '/shared-chat/:chatId',
    name: 'shared-chat',
    component: () => import('./views/SharedChatView.vue'),
    meta: { public: true },
  },
];
